function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Box from './Box';
import Carousel from './Carousel';
import Flex from './Flex';
import Image from './Image';
import Overlay from './Overlay';
const noop = () => {};
const ImageCarouselOverlay = /*#__PURE__*/React.memo(_ref => {
  let {
    images,
    onClose = noop,
    ...props
  } = _ref;
  const [isNoticeVisible, setIsNoticeVisible] = React.useState(Array.isArray(images) && images.length > 1);
  const reactSlickRef = React.useRef(null);
  const handlePrevious = React.useCallback(() => {
    reactSlickRef.current && reactSlickRef.current.slickPrev();
  }, []);
  const handleNext = React.useCallback(() => {
    reactSlickRef.current && reactSlickRef.current.slickNext();
  }, []);
  const handleImageClick = React.useCallback(evt => {
    evt.preventDefault();
    evt.stopPropagation();
  }, []);
  const handleKeyDown = React.useCallback(event => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      handlePrevious();
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      handleNext();
    }
  }, [handleNext, handlePrevious]);
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
  const handleSlideChange = () => setIsNoticeVisible(false);
  return /*#__PURE__*/React.createElement(Overlay, {
    onClose: onClose
  }, isNoticeVisible && /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      top: 0,
      width: '100vw',
      p: 3,
      textAlign: 'center',
      bg: 'primary',
      color: 'white',
      fontSize: [1, 2],
      zIndex: 1
    }
  }, "Swipe or use arrow keys to view photos"), /*#__PURE__*/React.createElement(Carousel, {
    ref: reactSlickRef,
    arrows: false,
    beforeChange: handleSlideChange
  }, images.map(image => /*#__PURE__*/React.createElement(Box, {
    key: image.src
  }, /*#__PURE__*/React.createElement(Flex, {
    onClick: onClose,
    sx: {
      width: '100vw',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Image, _extends({}, image, {
    sx: {
      maxWidth: '85vw',
      maxHeight: '85vh'
    },
    onClick: handleImageClick
  })))))));
});
ImageCarouselOverlay.propTypes = {
  images: PropTypes.array.isRequired,
  onClose: PropTypes.func
};
ImageCarouselOverlay.displayName = 'ImageCarouselOverlay';
export default ImageCarouselOverlay;